




































import Vue from 'vue'
import Component from 'vue-class-component'
import { mapState } from 'vuex'
import { Action } from 'vuex-class'
import FormSwitch from '@/components/FormSwitch.vue'
import { Settings } from '@/store/context/contextTypes'
import JavascriptAPI from '@/utils/JavascriptAPI'

@Component({
  computed: {
    ...mapState({
      user: (state: any): boolean => state.context.user,
      config: (state: any): boolean => state.context.config,
      settings: (state: any): boolean => state.context.settings
    })
  },
  components: {
    FormSwitch
  }
})

export default class RememberMeSettings extends Vue {
  settings: Settings
  rememberDevice: boolean
  storeData: boolean
  @Action('toggleRememberDevice', { namespace: 'context' }) toggleRememberDevice: any
  @Action('toggleStoreData', { namespace: 'context' }) toggleStoreData: any

  loaded = false

  beforeMount () {
    this.rememberDevice = this.settings.rememberDevice
    this.storeData = this.settings.storeData
  }
  mounted () {
    JavascriptAPI.__REPORT_CLIENT_HEIGHT__(100)
    setTimeout(() => {
      this.loaded = true
    }, 200)
  }
}

